<div class="py2">
  <unite-file-upload [object]="object()" [objectType]="objectType()" [text]="uploadButtonText()" (newFile)="newFile()"
  [customer]="customer()" [documentTypes]="documentTypes" [customers]="customers" [applications]="applications" [mortgages]="mortgages" [buildings]="buildings">
  </unite-file-upload>

  <unite-files-tab [type]="objectType()" [object]="object()"  [loadDocument]="loadDocument" [customer]="customer()" [documentTypes]="documentTypes" [customers]="customers"
  [applications]="applications" [mortgages]="mortgages" [buildings]="buildings" icon="select_all" [title]="'Documents' | translate"></unite-files-tab>
</div>
